package one.healthium.insights.ui.components.items

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.ui.NetworkImage

@Composable
internal fun ContentImage(
    modifier: Modifier = Modifier,
    item: ContentEntry.ImageEntry,
) {
    NetworkImage(
        modifier = modifier
            .fillMaxWidth()
            .then(
                if (item.height != null) {
                    Modifier.height(item.height.dp)
                } else {
                    Modifier
                },
            ),
        imageUrl = item.url,
        contentScale = if (item.height != null) {
            ContentScale.Crop
        } else {
            ContentScale.Inside
        },
    )
}